<template>
  <div id="app">
    <div class="wrap">
      <header-nav></header-nav>
      <router-view class="all-content"></router-view>
    </div>
    <!--ali������-->
    <ali-video-player></ali-video-player>
  </div>
</template>

<script>
import headerNav from './components/header-nav/header-nav'
import AliVideoPlayer from 'src/components/ali-video-player/index'

export default {
  name: 'App',
  components: {
    headerNav,
    AliVideoPlayer
  }
}
</script>

<style>
  @import "styles/base/reset.css";

  html {
    width: 100%;
    height: 100%;
  }
  body {
    width: 100%;
    height: 100%;
  }
  #app {
    width: 100%;
    height: 100%;
    -webkit-font-smoothing: antialiased;
    font-family: 'Hiragino Sans GB', 'microsoft yahei', arial, sans-serif;
    margin: 0 auto;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .all-content {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue